export enum ImageType
{
    MMLNotConnected,
    MMLConnected,
    MMLTemporaryConnection,
    CKCCProgramExistButPatientNotEnrolled,
    CKCCEnrolled,
    GroupNoteNotification,
    TelehealthNotification,
    TrickleImportNotification,
    BlankImage
}

export const blankImageUrl = "/officemd/images/blank.gif";

export const choiceImageTypeUrls: Record<ImageType, string> = 
{
    [ImageType.MMLNotConnected]: "/officemd/resources/img/icon/mmlnotconnected.png",
    [ImageType.MMLConnected]: "/officemd/resources/img/icon/mmlconnected.png",
    [ImageType.MMLTemporaryConnection]: "/officemd/resources/img/icon/mmladmin.png",
    [ImageType.CKCCProgramExistButPatientNotEnrolled]: "/officemd/resources/img/icon/kidney_inactive.png",
    [ImageType.CKCCEnrolled]: "/officemd/resources/img/icon/kidney_active.png",
    [ImageType.GroupNoteNotification]: "/officemd/resources/img/icon/notification/groupnote.png",
    [ImageType.TelehealthNotification]: "/officemd/resources/img/icon/notification/telehealth.png",
    [ImageType.TrickleImportNotification]: "/officemd/resources/img/icon/eDocuments16.png",
    [ImageType.BlankImage]: blankImageUrl
};

